// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import ConfirmDialog, { ConfirmDialogProps } from './ConfirmDialog';

export type { ConfirmDialogProps };
export default ConfirmDialog;
